import { render, staticRenderFns } from "./amrPlayer.vue?vue&type=template&id=495f6bd0&scoped=true&"
import script from "./amrPlayer.vue?vue&type=script&lang=js&"
export * from "./amrPlayer.vue?vue&type=script&lang=js&"
import style0 from "./amrPlayer.vue?vue&type=style&index=0&id=495f6bd0&lang=less&scoped=true&"
import style1 from "./amrPlayer.vue?vue&type=style&index=1&id=495f6bd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f6bd0",
  null
  
)

export default component.exports